var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45299 5.97207C9.45299 6.06679 9.42202 6.14967 9.3601 6.22071C9.23624 6.36279 9.04014 6.36279 8.92661 6.22071L5.24198 1.99383L1.52638 6.25623C1.40252 6.39831 1.20642 6.39831 1.09289 6.25623C0.969037 6.11415 0.969037 5.88919 1.09289 5.75895L5.24198 0.999272L9.3601 5.71159C9.42202 5.78263 9.45299 5.87735 9.45299 5.97207Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.148a4ffc755430ea1d9a5d2281a16329.svg";
export { ForwardRef as ReactComponent };